var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_10_750)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9516 20.3726L9.61525 17.0326C9.52801 16.9442 9.42411 16.874 9.30956 16.8261C9.19502 16.7782 9.07212 16.7535 8.94799 16.7535C8.82385 16.7535 8.70095 16.7782 8.58641 16.8261C8.47186 16.874 8.36796 16.9442 8.28072 17.0326C8.19241 17.1199 8.1223 17.224 8.07445 17.3386C8.02659 17.4533 8.00195 17.5763 8.00195 17.7006C8.00195 17.8249 8.02659 17.9479 8.07445 18.0626C8.1223 18.1772 8.19241 18.2813 8.28072 18.3686L12.2748 22.367C12.6466 22.7392 13.2471 22.7392 13.6189 22.367L23.7232 12.2612C23.8115 12.1739 23.8816 12.0699 23.9295 11.9552C23.9773 11.8405 24.002 11.7175 24.002 11.5932C24.002 11.4689 23.9773 11.3459 23.9295 11.2312C23.8816 11.1166 23.8115 11.0126 23.7232 10.9252C23.6359 10.8368 23.532 10.7666 23.4175 10.7187C23.303 10.6708 23.1801 10.6461 23.0559 10.6461C22.9318 10.6461 22.8089 10.6708 22.6943 10.7187C22.5798 10.7666 22.4759 10.8368 22.3887 10.9252L12.9516 20.3726Z",
    fill: "url(#paint1_linear_10_750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_750",
    x1: 36.2781,
    y1: 32,
    x2: -4.45658,
    y2: 29.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_750",
    x1: 26.141,
    y1: 22.6462,
    x2: 5.83248,
    y2: 20.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/card__arrow.89bd89fae8db7ce818a040f9d4d56260.svg";
export { ForwardRef as ReactComponent };